import React from 'react';

import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import FormContainer from '../../../FormContainer';
import Spinner from '../../../../Spinner';

import { useUiContext } from '../../../../../context/UiContext';
import useVendorForm from '../../../../../forms/vendor/vendor';
import VendorService from '../../../../../services/VendorService';

export default function Vendor({ id, vendor, isEdit }) {
  const { showToast } = useUiContext();

  const navigate = useNavigate();

  const { mutate: createVendor, isPending: isCreatingVendor } = useMutation({
    mutationFn: VendorService.createVendor,
    onSuccess: () => {
      showToast({ type: 'success', text: 'Vendor created' });
      navigate('/vendors');
    },
    onError: (error) => {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const { mutate: updateVendor, isPending: isUpdatingVendor } = useMutation({
    mutationFn: async (formValues) => {
      return VendorService.updateVendor({
        id,
        formValues,
      });
    },
    onSuccess: () => {
      showToast({ type: 'success', text: 'Servicer updated' });
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const vendorForm = useVendorForm(id ? updateVendor : createVendor, vendor);

  const isLoading = isCreatingVendor || isUpdatingVendor;

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <FormContainer
        form={vendorForm}
        disabled={isLoading}
        noBillComId={!isEdit}
      />
      {isLoading && <Spinner />}
    </div>
  );
}
